export default "__VITE_ASSET__4c58189d__"